import { Locale } from '@moonpig/web-core-locale-text'
import { formatPrice } from '@moonpig/web-core-utils'

type FormattedPriceForSelector = {
  centAmount: number
  fractionDigits: number
  currencyCode: string
}

export type FormattedVariantForSelectorPricing = {
  discountedPercentage?: number | null
  price: FormattedPriceForSelector
  fullPrice: FormattedPriceForSelector
}

const formatSelectorPrice = (
  { centAmount, fractionDigits, currencyCode }: FormattedPriceForSelector,
  language: Locale,
) =>
  formatPrice(Math.abs(centAmount), fractionDigits, currencyCode, 1, language)

export const getFormattedVariantSelectorPriceFields = (
  formattedVariant: FormattedVariantForSelectorPricing,
  language: Locale,
) => {
  const salePrice = formatSelectorPrice(formattedVariant.price, language)
  const fullPrice = formatSelectorPrice(formattedVariant.fullPrice, language)

  if (formattedVariant.discountedPercentage) {
    return {
      price: fullPrice,
      discountedPrice: salePrice,
      absolutePrice: fullPrice,
    }
  }

  return {
    price: salePrice,
    absolutePrice: fullPrice,
  }
}
